module.exports = __webpack_public_path__ + "static/media/39.3b33ca5f.wav";